<template>
  <div>
    <div class="mui-content">
      <form id="login-form" class="mui-input-group">
        <div class="mui-input-row">
          <label>账号</label>
          <input
            id="account"
            type="text"
            class="mui-input-clear mui-input"
            v-model="username"
            placeholder="请输入账号/电话/身份证号码"
          />
        </div>
        <div class="mui-input-row">
          <label>密码</label>
          <input
            id="password"
            type="password"
            class="mui-input-clear mui-input"
            v-model="password"
            placeholder="请输入密码"
          />
        </div>
      </form>
      <div class="mui-content-padded">
        <button
          id="login"
          type="button"
          class="mui-btn mui-btn-block mui-btn-primary"
          @click="login"
        >
          登录
        </button>
      </div>
      <div class="mui-content-padded other-div">
        <router-link to="/user/smslogin">短信登录</router-link>
        /
        <router-link to="/user/register">没有账号注册</router-link>
        <!--        /-->
        <!--        <router-link to="/user/changePassword">忘记密码</router-link>-->
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      areaList: [], //用户对应城市所在区域
      title: "用户登录",
    };
  },
  methods: {
    login() {
      var that = this;
      that.areaList = [
        {
          id: -1,
          name: "全部区域",
        },
      ];
      if (this.username === "" || this.password === "") {
        Toast("账号密码不能为空");
        return false;
      }
      this.$http
        .post(
          "api/gather/Login",
          {
            username: this.username,
            password: this.password,
            openid: window.localStorage.getItem("userOpenid"),
          },
          { emulateJSON: true }
        )
        .then(function (data) {
          Toast(data.body.msg);
          if (data.body.code === 1) {
            window.localStorage.setItem("uid", data.body.data.uid);
            var areaList = data.body.data.arealist;
            for (var i = 0; i < areaList.length; i++) {
              that.areaList.push({
                id: i,
                name: areaList[i].area,
              });
            }
            localStorage.setItem("areaList", JSON.stringify(that.areaList));
            setTimeout(() => {
              this.$router.push({ path: "/home" });
            }, 2000);
          }
        });
    },
  },
  created() {
    this.$emit("getTitle", this.title);
  },
};
</script>

<style scoped>
.mui-content {
  margin-top: 5%;
}

.other-div {
  text-align: center;
  float: right;
  font-size: 16px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/login.vue